import React, { useEffect, useRef, useState } from 'react'
import Login from './Login';
import Signup from './Signup/Signup';

import { useDispatch, useSelector } from 'react-redux';
import Loading from '../Loading';
import { modalChange } from '../../redux/slices/AuthSlice';



const Auth = () => {
  const dispatch=useDispatch();
    const [authFlag,setAuthFlag]=useState(0);
    const {isLoading,modal}=useSelector((state)=>state.AuthReducer);
    const open_auth=()=>{
      dispatch(modalChange());
     }
     useEffect(() => {

      if(modal){
        document.body.style.overflow="hidden"
      }else{
        document.body.style.overflow="auto"
      }
    }, [modal]);
  return (
    <div className="modal_fade" style={{ display:!modal&&'none'}}>
    <div className="modal-dialog">
      <div className="modal-content login container-fluid" >
      {isLoading?(<Loading/>):(
        <div>
  <div className="login-close">
      <button className='login-button sign-button'  onClick={()=>setAuthFlag(!authFlag)}>
          {authFlag?'تسجيل دخول':'انشاء حساب'}
      </button>
        <i className="fa-solid fa-xmark" onClick={open_auth}></i>
      </div>
      {authFlag?<Signup/>:<Login />}
        </div>
      )}
      </div>
      
      
       
    </div>
  </div>  
  )
}

export default Auth
